import daDK from 'antd/es/locale/da_DK';
import deDE from 'antd/es/locale/de_DE';
import enUS from 'antd/es/locale/en_US';
import esES from 'antd/es/locale/es_ES';
import fiFI from 'antd/es/locale/fi_FI';
import frFR from 'antd/es/locale/fr_FR';
import itIT from 'antd/es/locale/it_IT';
import jaJP from 'antd/es/locale/ja_JP';
import nbNO from 'antd/es/locale/nb_NO';
import nlNL from 'antd/es/locale/nl_NL';
import ptBR from 'antd/es/locale/pt_BR';
import ptPT from 'antd/es/locale/pt_PT';
import svSE from 'antd/es/locale/sv_SE';
import zhCN from 'antd/es/locale/zh_CN';
import zhHK from 'antd/es/locale/zh_HK';
export const antdLocaleMap = {
    en: enUS,
    da: daDK,
    de: deDE,
    es: esES,
    fr: frFR,
    it: itIT,
    ja: jaJP,
    nl: nlNL,
    no: nbNO,
    fi: fiFI,
    sv: svSE,
    zh: zhCN
};
export const getAntdLocale = (locale)=>{
    const key = locale === null || locale === void 0 ? void 0 : locale.toLowerCase();
    if (antdLocaleMap[key]) {
        return antdLocaleMap[key];
    }
    if (key === 'pt-br') {
        return ptBR;
    }
    if (key === 'pt-pt') {
        return ptPT;
    }
    if (key === 'zh-hk') {
        return zhHK;
    }
    // Fall back to base language (e.g. es-419 → es)
    const baseLanguage = key === null || key === void 0 ? void 0 : key.split('-')[0];
    return antdLocaleMap[baseLanguage] || antdLocaleMap.en;
};
